module.exports = "<span ng-bind=\"$parent.row.activation.amplified.activated_date | date:'MMM d, y'\"></span>"